import { surfaceForClient } from '../../lib/mcpClientIcons';

export function ClientIcon({
  clientName,
  size = 'md',
}: {
  clientName: string;
  size?: 'sm' | 'md';
}) {
  const surface = surfaceForClient(clientName);
  if (!surface) return null;
  const wrap = size === 'sm' ? 'h-4 w-4' : 'h-6 w-6';
  const mark = size === 'sm' ? 'h-2.5 w-2.5' : 'h-3.5 w-3.5';
  return (
    <span
      title={surface.name}
      className={`inline-flex ${wrap} shrink-0 items-center justify-center rounded-full bg-white ring-1 ring-gray-200`}
    >
      <img
        src={surface.logoSrc}
        alt=""
        className={`${mark} object-contain`}
      />
    </span>
  );
}

export function ConnectedClientBadges({ clients }: { clients: string[] }) {
  if (clients.length === 0) {
    return (
      <p className="text-sm text-gray-500 dark:text-gray-400">Never connected</p>
    );
  }

  return (
    <ul className="flex flex-wrap items-center gap-2" aria-label="Connected AI tools">
      {clients.map((name) => {
        const surface = surfaceForClient(name);
        const label = surface?.name ?? name;
        return (
          <li
            key={name}
            className="inline-flex items-center gap-2 rounded-full border border-gray-200 bg-white py-1 pl-1 pr-3 dark:border-gray-600 dark:bg-gray-800"
          >
            <span className="flex h-7 w-7 items-center justify-center rounded-full bg-white ring-1 ring-gray-200">
              {surface ? (
                <img
                  src={surface.logoSrc}
                  alt=""
                  className="h-4 w-4 object-contain"
                />
              ) : (
                <span className="text-[10px] font-semibold text-gray-500">
                  {label.slice(0, 1).toUpperCase()}
                </span>
              )}
            </span>
            <span className="text-sm font-medium text-gray-800 dark:text-gray-100">
              {label}
            </span>
          </li>
        );
      })}
    </ul>
  );
}
